import { commitOptions } from "./commitSeams";
import { api } from "@/lib/api/client";

export interface GradeBand {
  letter: string;
  min_score: number;
  gpa_points: number;
}

export interface GradeScale {
  ratified: boolean;
  bands: GradeBand[];
  /** The scale's own version, moved by every save to it. */
  grade_scale_version: number;
}

/**
 * A save names the version it was made against. When the scale has moved
 * since, the server refuses with 409 and the current scale as `current`.
 */
export interface PatchGradeScale {
  expected_version: number;
  ratified?: boolean;
  bands?: GradeBand[];
}

export const gradeScaleApi = {
  getGradeScale: () => api.get<GradeScale>("/grade-scale"),
  putGradeScale: (body: PatchGradeScale, key: string) => api.patch<GradeScale & { committed_version?: number }>("/grade-scale", body, commitOptions(key)),
};
